module.exports = __webpack_public_path__ + "img/customerService.669b56e.webp";